export function stringToBoolean(string: string | boolean): boolean {
  return string === true || string === 'true';
}
